import React from 'react';
import './Footer.css';
import headerlogo from '../assets/logo.svg';
import IconFacebook from '../assets/facebook.svg';
import IconInstagram from '../assets/instagtam.svg';
import IconX from '../assets/twitter.svg';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="site-footer__container">
                <div className="site-footer__left">
                    <div className="site-logo">
                        <a href="/">
                            <img src={headerlogo} alt="Site Logo" />
                        </a>
                    </div>
                </div>

                <div className="site-footer__right">
                    <div className="social-icons">
                        <a href="https://www.facebook.com" className="social-icon" aria-label="Facebook">
                            <img src={IconFacebook} alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com" className="social-icon" aria-label="Instagram">
                            <img src={IconInstagram} alt="Instagram" />
                        </a>
                        <a href="https://www.x.com" className="social-icon" aria-label="X">
                            <img src={IconX} alt="X" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
